import { render, staticRenderFns } from "./NewsPoster.vue?vue&type=template&id=c9722d2a&"
import script from "./NewsPoster.vue?vue&type=script&lang=js&"
export * from "./NewsPoster.vue?vue&type=script&lang=js&"
import style0 from "./NewsPoster.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports